// extracted by mini-css-extract-plugin
export default {"box":"style_box__OJ3Xm","footer":"style_footer__+nPUn"};